import { inject, type ComputedRef } from 'vue'
import AuthenticatedUser from '@/entities/authenticated-user'
import { authKey } from '@/plugins/authentication'

export function useAuth() {
  const user = inject<ComputedRef<AuthenticatedUser> | null>(authKey, null)

  if (!user) {
    throw new Error('useAuth must be used after AuthenticationPlugin')
  }

  return { user }
}
